<template>
  <basic-container>
    <el-card class="box-card" :body-style="{ padding: '0' }">
      <el-form label-width="110px" :model="formState" ref="formState" :inline="true" size="small">
        <el-form-item label="活动名称" class="flex-1">
          <el-input
            clearable
            style="width: 200px"
            v-model="formState.name"
            placeholder="请输入活动名称"
          />
        </el-form-item>
        <el-form-item label="状态：">
          <el-select
            @change="topTypeChange"
            clearable
            style="width: 200px"
            placeholder="请选择"
            v-model="formState.state"
          >
            <el-option
              v-for="item in stateList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间：" class="flex-1">
          <el-date-picker
            v-model="formState.startTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 200px"
            type="datetime"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item label="创建人：" class="flex-1">
          <el-input
            clearable
            style="width: 200px"
            v-model="formState.createUserInfo"
            placeholder="请输入姓名或手机号"
          />
        </el-form-item>
        <el-form-item label="隶属公司" prop="merchantId">
          <YdMerchantSelector
            v-model="formState.merchantId"
            placeholder="请选择隶属公司"
            @change="onChange"
          />
        </el-form-item>
        <el-form-item label="线路" prop="lineId">
          <YdLineSelector
            v-model="formState.lineId"
            :disabled="!formState.merchantId"
            placeholder="请选择活动路线"
            :merchantId="formState.merchantId"
          />
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-search"
            @click="onSearch"
            :loading="loading"
            >查询</el-button
          >
          <el-button
            type="danger"
            size="mini"
            icon="el-icon-delete"
            @click="onClear('formState')"
            :loading="loading"
            >清除</el-button
          >
          <el-button
            v-has-permi="['order_reduce_add']"
            type="primary"
            size="mini"
            icon="el-icon-plus"
            @click="add"
            >新建活动</el-button
          >
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="margin-top-10" :body-style="{ padding: '0' }">
      <yd-table
        :loading="loading"
        :data="list"
        ref="agentTable"
        border
        highlight-current-row
        max-height="680"
        @onChange="onTableChange"
        :pagination="pagination"
      >
        <el-table-column
          fixed="left"
          align="left"
          prop="name"
          label="活动名称"
          width="150"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-button @click="handle(scope.row, 'detail')" size="mini" type="text">{{
              scope.row.name
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="优惠类型"
          prop="tiaoJianStr"
          width="120"
          :show-overflow-tooltip="true"
          align="center"
        />
        <el-table-column
          label="优惠"
          width="160"
          prop="youhui"
          :show-overflow-tooltip="true"
          align="left"
        />
        <el-table-column
          width="200"
          label="隶属公司"
          prop="merchantNames"
          :show-overflow-tooltip="true"
          align="left"
        />
        <el-table-column
          width="150"
          label="线路"
          prop="lineNames"
          :show-overflow-tooltip="true"
          align="left"
        />
        <el-table-column
          width="180"
          label="开始时间"
          prop="startTime"
          :show-overflow-tooltip="true"
          align="center"
        />
        <el-table-column
          width="180"
          label="结束时间"
          prop="endTime"
          :show-overflow-tooltip="true"
          align="left"
        />
        <el-table-column
          label="创建人"
          width="120"
          prop="createUserName"
          :show-overflow-tooltip="true"
          align="center"
        />
        <el-table-column
          label="创建时间"
          width="180"
          prop="createTime"
          :show-overflow-tooltip="true"
          align="center"
        />
        <el-table-column
          label="状态"
          width="120"
          prop="stateStr"
          :show-overflow-tooltip="true"
          align="center"
        />
        <el-table-column fixed="right" width="180" label="操作" align="center">
          <template slot-scope="scope">
            <div class="flex-center" v-loading="handleLoading && scope.row.id === now.id">
              <el-button
                v-has-permi="['order_reduce_edit']"
                @click="handle(scope.row, 'edit')"
                v-if="[1, 2, 3, 5].includes(scope.row.state)"
                size="mini"
                type="text"
                >编辑</el-button
              >
              <el-popconfirm
                v-has-permi="['order_reduce_pass']"
                v-if="scope.row.state === 1"
                @confirm="handle(scope.row, 1)"
                title="确定通过吗？"
              >
                <el-button class="margin-left-5" slot="reference" size="mini" type="text"
                  >通过</el-button
                >
              </el-popconfirm>
              <!-- <el-popconfirm v-if="scope.row.state === 1" @confirm="handle(scope.row, 0)" title="确定不通过吗？"> -->
              <el-button
                v-has-permi="['order_reduce_reject']"
                v-if="scope.row.state === 1"
                @click="handle(scope.row, 0)"
                slot="reference"
                class="margin-left-5"
                size="mini"
                type="text"
                >不通过</el-button
              >
              <!-- </el-popconfirm> -->

              <el-popconfirm
                v-has-permi="['order_reduce_online']"
                v-if="scope.row.state === 5"
                @confirm="handle(scope.row, 3)"
                title="确定上架吗？"
              >
                <el-button slot="reference" class="margin-left-5" size="mini" type="text"
                  >上架</el-button
                >
              </el-popconfirm>
              <el-popconfirm
                v-has-permi="['order_reduce_offline']"
                v-if="[3, 4].includes(scope.row.state)"
                @confirm="handle(scope.row, 2)"
                title="确定下架吗？"
              >
                <el-button slot="reference" class="margin-left-5" size="mini" type="text"
                  >下架</el-button
                >
              </el-popconfirm>
              <el-button
                v-has-permi="['order_reduce_data']"
                class="margin-left-5"
                @click="handle(scope.row, 'data')"
                v-if="[4, 2, 5].includes(scope.row.state)"
                size="mini"
                type="text"
                >数据</el-button
              >
            </div>
          </template>
        </el-table-column>
      </yd-table>
    </el-card>
    <modify @onSuccess="onSuccess" ref="modify" />
    <detail ref="detail" />
    <data-list ref="data" />
  </basic-container>
</template>

<script>
  import {
    getConst,
    modifyComplaint,
    getReduceList,
    getUserByMerchant,
    setPlatNoticeUser,
    getPlatUser,
    changeState
  } from '@/api'
  import modify from './modify.vue'
  import detail from './detail.vue'
  import DataList from './data'
  let constList = {}
  const constTable = {
    0: 'ComplaintDriverLabel',
    1: 'ComplaintApplicationLabel',
    2: 'ComplaintPlatformLabel',
    3: '-'
  }
  export default {
    name: 'OrderReduce',
    components: {
      modify,
      detail,
      DataList
    },
    data() {
      return {
        show: false,
        formState: {
          lineId: '',
          dealPerson: '',
          followPerson: '',
          processStatus: '',
          topType: '',
          userMobile: '',
          time: '',
          curDealByName: ''
        },
        complaintFom: {
          type: '0',
          res: '',
          subType: '',
          customPhone: '',
          labels: '',
          orderNo: '',
          remark: '',
          createTime: ''
        },

        rules: {
          type: [{ required: true, message: '请选择投诉类型', trigger: 'change' }],
          res: [{ required: true, message: '请选择来源', trigger: 'change' }],
          subType: [{ required: true, message: '请选择类型', trigger: 'change' }],
          labels: [{ required: true, message: '请选择标签', trigger: 'blur' }],
          orderNo: [{ required: false, message: '请输入订单号', trigger: 'blur' }],
          remark: [{ required: true, message: '请输入内容', trigger: 'blur' }],
          createTime: [{ required: true, message: '请选择时间', trigger: 'blur' }],
          customPhone: [
            { required: true, message: '请输入电话', trigger: 'blur' },
            { min: 11, max: 11, message: '请输入正确的电话', trigger: 'blur' }
          ]
        },
        routeList: [],
        tmpId: '',
        typeList: ['', 'success', 'info', 'danger', 'warning'],
        lineData: [],
        dialogImageUrl: '',
        dialogVisible: false,
        dicList: [],
        typeLists: [],
        topList: [],
        subTypeList: [],
        nowType: {},
        subType: [],
        resList: [],
        list: [],
        statusList: [],
        picUrls: '',
        showNotice: false,
        platUser: [],
        leadUser: [],
        platUserList: [],
        leaderUserList: [],
        noticeForm: {
          platId: '',
          platUser: '',
          leaderId: '',
          leaderUser: ''
        },
        submitLoading: false,
        upLoading: false,
        stateList: [
          { value: 1, label: '待审核' },
          { value: 2, label: '审核不通过' },
          { value: 3, label: '未开始' },
          { value: 4, label: '进行中' },
          { value: 5, label: '下架' }
        ],
        handleLoading: false,
        now: {},
        loading: false
      }
    },
    created() {
      this.getConstList()
      // this.getList()
    },
    mounted() {},
    methods: {
      onTableChange({ current, pageSize }) {
        this.pagination.page = current
        this.pagination.size = pageSize
        this.getList()
      },
      onChange(e) {
        this.formState.lineId = ''
      },
      onSuccess(type) {
        if (type === 'add') {
          this.pagination.page = 1
        }
        this.getList()
      },
      async handle(item, type) {
        if (type === 'edit') {
          this.$refs.modify.edit(item)
          return
        }
        if (type === 'detail') {
          this.$refs.detail.getDetail(item)
          return
        }
        if (type === 'data') {
          this.$refs.data.init(item)
          return
        }
        this.now = item
        if (type === 0) {
          this.$prompt('请输入原因', '审核不通过', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputType: 'textarea',
            inputPattern: /.+/,
            inputErrorMessage: '请输入不通过原因'
          })
            .then(async ({ value }) => {
              this.handleLoading = true
              const { code } = await changeState({
                shiFou: type,
                activityLiJianNo: item.activityLiJianNo,
                remark: value
              })
              this.handleLoading = false
              if (code === 0) {
                this.getList()
              }
            })
            .catch(() => {})
          return
        }
        this.handleLoading = true
        const { code } = await changeState({
          shiFou: type,
          activityLiJianNo: item.activityLiJianNo,
          remark: ''
        })
        this.handleLoading = false
        if (code === 0) {
          this.getList()
        }
      },
      topTypeChange(v) {
        this.formState.subType = ''
        if (+v === 0 || +v === 2) {
          this.subTypeList = constList.ComplaintType
        } else {
          this.subTypeList = constList.SuggestionType
        }
      },
      typeChange(v) {
        this.complaintFom.subType = ''
        this.complaintFom.labels = []
        if (+v === 1) {
          this.typeLists = constList.SuggestionType
        } else {
          this.typeLists = constList.ComplaintType
        }
      },
      onSubmitNotice() {
        const { platUser = [] } = this
        if (!platUser.length) {
          this.$message.warning('请选择平台通知人')
          return
        }
        this.submitLoading = true
        setPlatNoticeUser({
          ids: platUser.map((item) => item.userId)
        })
          .then((res) => {
            this.submitLoading = false
            if (res.code === 0) {
              this.showNotice = false
            }
          })
          .catch(() => {
            this.submitLoading = false
          })
      },
      getPlatNoticeUser() {
        getPlatUser().then((res) => {
          if (res.code === 0) {
            this.platUser = res.data
          }
        })
      },
      onUserChange(userId, type) {
        if (!userId) {
          return
        }
        if (type === 'plat') {
          if (this.platUser.some((item) => item.userId === userId)) {
            return
          }
          const user = this.platUserList.find((item) => item.userId === userId)
          this.platUser.push(user)
        } else {
          if (this.leadUser.some((item) => item.userId === userId)) {
            return
          }
          const user = this.leaderUserList.find((item) => item.userId === userId)
          this.leadUser.push(user)
        }
      },
      getUser(merchantId, type) {
        this.noticeForm.platUser = ''
        if (!merchantId) {
          return
        }
        getUserByMerchant({ merchantId }).then((res) => {
          if (res.code === 0) {
            if (type === 'plat') {
              this.platUserList = res.data
            } else {
              this.leaderUserList = res.data
            }
          }
        })
      },
      addNotice() {
        this.showNotice = true
        this.getPlatNoticeUser()
      },
      onSubmit(formName) {
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            /* if (!this.picUrls.length) {
              this.$message.error('请上传图片！')
              return
            } */
            this.upLoading = true
            const { orderNo, labels, customPhone, createTime, ...rest } = this.complaintFom
            const params = {
              processDto: {
                ...rest,
                createTime: createTime + ':00',
                labels: labels.join(','),
                picUrls: this.picUrls
              },
              complaintSuggestionDto: {
                customPhone
              }
            }
            if (orderNo) {
              params.complaintSuggestionDto.orderNo = orderNo
            }
            const { code } = await modifyComplaint(params)
            this.upLoading = false
            if (code === 0) {
              this.onClear(formName, 'show')
              this.pagination.page = 1
              this.$refs.uploadImage.reset()
              this.getList()
            }
          }
        })
      },
      handleCurrentChange(val) {
        this.pagination.page = val
        this.getList()
      },
      handleSizeChange(val) {
        this.pagination.pageSize = val
        this.getList()
      },
      async getList() {
        const { ...rest } = this.formState
        this.loading = true
        const params = {}
        for (const [k, v] of Object.entries(rest)) {
          if (v !== '') {
            params[k] = v
          }
        }
        const { code, data } =
          (await getReduceList({
            size: this.pagination.pageSize,
            page: this.pagination.page,
            ...params
          })) || {}
        this.loading = false
        if (code === 0) {
          const { records = [], total, pages, current } = data || {}
          this.pagination = {
            ...this.pagination,
            total,
            page: current,
            pages
          }
          this.list = records
          return
        }
        this.list = []
      },
      initType() {
        const { value } = this.nowType
        this.subType = constList[constTable[value]] || []
      },
      changeLabel(hit) {
        this.subType = this.subType.map((item) => ({
          ...item,
          active: hit.value === item.value ? !item.active : item.active
        }))
      },
      async changeType(v, className) {
        this.nowType = this.typeLists.find((item) => item.value === v)
        this.complaintFom.labels = []
        this.initType()
      },
      getConstList() {
        getConst().then((res) => {
          if (res.code === 0) {
            constList = res.data
            this.statusList = res.data.ProcessStatus
            this.resList = res.data.ComplaintResource.filter(
              (item) => ![0, 7, 8].includes(item.value)
            )
            this.typeLists = res.data.ComplaintType
            this.topList = res.data.TopType
            this.subTypeList = res.data.ComplaintType
            this.nowType = res.data.ComplaintType[0]
            this.initType()
          }
        })
      },
      handleSuccess(urls) {
        this.picUrls = urls
      },
      handleRemove(file, fileList) {
        console.log(file, fileList)
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url
        this.dialogVisible = true
      },
      // 下拉获取线路数据
      handleLineSelect(val) {
        this.tmpId = val
        if (!val) {
          return
        }
        const now = this.lineData.find((item) => item.id === val)
        if (this.routeList.length > 0) {
          const has = this.routeList.findIndex((item) => item.id === val) !== -1
          if (!has) {
            this.routeList.push(now)
            const time = setTimeout(() => {
              this.tmpId = ''
              clearTimeout(time)
            }, 500)
          }
          return
        }
        this.routeList.push(now)
        const time = setTimeout(() => {
          this.tmpId = ''
          clearTimeout(time)
        }, 500)
      },
      handleClose(index, type) {
        if (type === 'platUser') {
          this.platUser.splice(index, 1)
        } else {
          this.leadUser.splice(index, 1)
        }
      },
      add() {
        this.$refs.modify.init()
      },
      editGlobalConfig() {
        this.showConfig = true
      },
      onSearch() {
        this.pagination.page = 1
        this.getList()
      },
      onClear(formName, field) {
        this.$refs[formName].resetFields()
        console.log(this.formState)
        this.formState = {
          dealPerson: '',
          followPerson: '',
          processStatus: '',
          topType: '',
          userMobile: '',
          time: '',
          curDealByName: ''
        }
        if (field) {
          this.closeDialog(field)
          return
        }
        this.pagination.page = 1
        this.getList()
      },
      closeDialog(field) {
        this[field] = false
      }
    }
  }
</script>
<style scoped lang="scss"></style>
